export const availableCountries = [
  {
    name: 'China',
    countryCode: 'CHN',
    market: 'GC',
  },
  {
    name: 'India',
    countryCode: 'IND',
    market: 'SA',
  },
  {
    name: 'Singapore',
    countryCode: 'SGP',
    market: 'SEA',
  },
  {
    name: 'Malaysia',
    countryCode: 'MYS',
    market: 'SEA',
  },
  {
    name: 'Indonesia',
    countryCode: 'IDN',
    market: 'SEA',
  },
  {
    name: 'Thailand',
    countryCode: 'THA',
    market: 'SEA',
  },
];

export const partnerType = {
  EDUCATION_AGENT: 'EDUCATION_AGENT',
  UNIVERSITY_INCLUDING_FEEDER: 'UNIVERSITY_INCLUDING_FEEDER',
  STUDENT_ASSOCIATION: 'STUDENT_ASSOCIATION',
  ONLINE: 'ONLINE',
  OTHER: 'OTHER',
  MARKETING_MEDIA_PARTNER: 'MARKETING_MEDIA_PARTNER',
  GLOBAL_EDUCATION_PARTNER: 'GLOBAL_EDUCATION_PARTNER',
  THIRD_PARTY_PARTNER_EASY_TRANSFER_USA: 'THIRD_PARTY_PARTNER_EASY_TRANSFER_USA',
  UNIVERSITY_STUDENT_AMBASSADOR: 'UNIVERSITY_STUDENT_AMBASSADOR',
  EDUCATION_PARTNER: 'EDUCATION_PARTNER',
  THIRD_PARTY_PARTNER_HOOLI_HOME: 'THIRD_PARTY_PARTNER_HOOLI_HOME',
  THIRD_PARTY_EDUCATION_RELATED_SERVICE_PROVIDER: 'THIRD_PARTY_EDUCATION_RELATED_SERVICE_PROVIDER',
  THIRD_PARTY_PARTNER_STUDAPART: 'THIRD_PARTY_PARTNER_STUDAPART',
  CHAT_GROUP: 'CHAT_GROUP',
  SOCIAL: 'SOCIAL',
  THIRD_PARTY_COMMERCIAL_PARTNERS: 'THIRD_PARTY_COMMERCIAL_PARTNERS',
};
